angular.module('zc.projects')

.directive 'zcPageTypeSample', ($filter, $q, PageTypeSampleUrl) ->
    restrict: 'A'
    scope:
      pageTypes: '='
      pageTypeSampleUrl: '='
      projectId: '='
      checkSampleMatchesPattern: '&'
      onDestroySampleUrl: '&'
    templateUrl: "/templates/projects.settings/initialization/page_type_sample.html"
    replace: true

    link: (scope, element, attrs) ->
      # select options
      scope.pageTypeOptions = []
      scope.devices = []
      $q.all [
        PageTypeSampleUrl.getPageTypeOptions scope.projectId
        PageTypeSampleUrl.getDevices scope.projectId
      ]
      .then ([pageTypes, devices]) ->
        for pageType in pageTypes
          scope.pageTypeOptions.push
            name: pageType[0]
            value: pageType[1]
        for device in devices
          scope.devices.push
            name: device[0]
            value: device[1]

      scope.checkSampleMatchesPattern()

      scope.isDestroying = false
      scope.remove = (pageTypeSampleUrl) ->
        if pageTypeSampleUrl.id # saved pageTypeSampleUrl
          scope.isDestroying = true
          PageTypeSampleUrl.destroy pageTypeSampleUrl
          .then (res) ->
            scope.onDestroySampleUrl?()
            scope.isDestroying = false
        else # unsaved pageTypeSampleUrl
          scope.onDestroySampleUrl?()
          scope.$apply()
          # TODO: move alertify into service?
          alertify.success($filter('translate')('projectsSettings.initialization.pageTypeSample.deleted'))

      scope.update = (pageTypeSampleUrl) ->
        handler = (pageTypeSampleUrl) ->
          angular.extend(scope.pageTypeSampleUrl, pageTypeSampleUrl)
          scope.form.$setPristine()
        if pageTypeSampleUrl.id
          PageTypeSampleUrl.update({ projectId: pageTypeSampleUrl.project_id, id: pageTypeSampleUrl.id}, {page_type_sample_url: pageTypeSampleUrl})
          .then handler
        else
          PageTypeSampleUrl.create({ projectId: pageTypeSampleUrl.project_id }, {page_type_sample_url: pageTypeSampleUrl})
          .then handler

      # always set dirty when creating new pageTypeSampleUrl
      unless scope.pageTypeSampleUrl.id
        scope.form.$setDirty()



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/initialization/page_type_sample.directive.coffee